'use client';

import dynamic from 'next/dynamic';

const GoogleTagManager = dynamic(() => import('.'), { ssr: false });

export default function GoogleTagManagerLoader() {
  return <GoogleTagManager />;
}
